<template>
  <m-popup
    v-model:visible="show"
    max-width="88%"
    :overlay="loading"
    overlay-class="feiyu-share-toast--overlay"
    position="center"
  >
    <div :class="['feiyu-share-toast', { 'feiyu-share-toast--loading': loading }]">
      <div class="feiyu-share-toast--content">
        <slot v-if="$slots.default" />
        <div v-else-if="loading" class="feiyu-share-toast--spinner" />
        <div v-else>{{ message }}</div>
      </div>
    </div>
  </m-popup>
</template>

<script lang="ts">
export default {
  emits: ["update:visible"],
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    message: { type: String, default: "" },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
};
</script>

<style lang="less">
.feiyu-share-toast {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(51, 51, 51, 0.7);
  color: #ffffff;
  line-height: 1;
}

.feiyu-share-toast--overlay {
  background: transparent;
}

.feiyu-share-toast--loading {
  padding: 16px 20px;
}

.feiyu-share-toast--content {
  font-size: 12px;
}

.feiyu-share-toast--spinner {
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.28);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: feiyu-share-toast-rotate 0.8s linear infinite;
}

@keyframes feiyu-share-toast-rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
